import React from "react";
import TopMenu from "../Header/topMenu";
import Slide from "react-reveal/Slide";

export default class TopMadoule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isTop: true
    };
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener("scroll", () => {
      const isTop = window.scrollY < 200;
      if (isTop !== this.state.isTop) {
        this.onScroll(isTop);
      }
    });
  }

  onScroll(isTop) {
    this.setState({ isTop });
  }

  render() {
    // const { isTop } = this.state;

    return (
      <div className="TopHeader">
        <div className="bannerTop">
          <Slide bottom>
            <p className="toplogo">سبا</p>
          </Slide>
          <Slide bottom>
            <p className="topsologon">
              <span className="highlightlogo">سامانه</span>
              اطلاع رسانی
              <span className="highlightlogo">بازار</span>
              <span className="highlightlogo">آهن</span>
              قراضه ایران
            </p>
          </Slide>
        </div>
        {/* <div className={isTop ? 'topmenue normalmenu' : 'topmenue scrollmenu'} > */}
        <div className="topmenue normalmenu">
          <TopMenu />
        </div>
      </div>
    );
  }
}
